module.exports = __webpack_public_path__ + "static/media/ae3.53327290.png";